import { render, staticRenderFns } from "./OrganizationAvatar.vue?vue&type=template&id=22290010&scoped=true"
import script from "./OrganizationAvatar.vue?vue&type=script&lang=js"
export * from "./OrganizationAvatar.vue?vue&type=script&lang=js"
import style0 from "./OrganizationAvatar.vue?vue&type=style&index=0&id=22290010&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22290010",
  null
  
)

export default component.exports